import { render, staticRenderFns } from "./wf-checkbox-list-display.vue?vue&type=template&id=24aeda52&scoped=true&"
import script from "./wf-checkbox-list-display.vue?vue&type=script&lang=ts&"
export * from "./wf-checkbox-list-display.vue?vue&type=script&lang=ts&"
import style0 from "./wf-checkbox-list-display.vue?vue&type=style&index=0&id=24aeda52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24aeda52",
  null
  
)

export default component.exports